import { RefAttributes, forwardRef } from 'react';
import type {
  StepperProps,
  StepperRef
} from '../jdshorizontalstepper/interface';

import { JDSVerticalStepperProps } from './generated/interface';
import { useStepper } from '../jdshorizontalstepper/stepperLogic';

export const withLogic = (
  Component: React.ComponentType<JDSVerticalStepperProps>
): React.ForwardRefExoticComponent<
  Omit<StepperProps, 'ref'> & RefAttributes<StepperRef>
> =>
  forwardRef<StepperRef, StepperProps>((props, stepperRef) => {
    const { stepItems } = useStepper(props, stepperRef);
    return (
      <Component
        {...{
          ...props,
          stepItems
        }}
      />
    );
  });

export { StepperProps, StepperRef };
